interface FormSubmitKeyTarget {
  tagName?: string;
  type?: string;
}

interface ShouldPreventImplicitFormSubmitParams {
  key: string;
  defaultPrevented: boolean;
  target: FormSubmitKeyTarget | null;
}

const NON_IMPLICIT_SUBMIT_INPUT_TYPES = new Set(["button", "reset", "submit"]);

export const shouldPreventImplicitFormSubmit = ({
  key,
  defaultPrevented,
  target,
}: ShouldPreventImplicitFormSubmitParams): boolean => {
  if (key !== "Enter" || defaultPrevented || target?.tagName !== "INPUT") {
    return false;
  }

  return !NON_IMPLICIT_SUBMIT_INPUT_TYPES.has(target.type?.toLowerCase() ?? "");
};
